import { useCallback } from 'react';

import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

import { useCanReportVideo } from './useCanReportVideo';

type Video = { id: string; user: { id: string } | null };

type Result = ModelHookResult<
	{ canReportVideo: boolean },
	{
		report: () => void;
	}
>;

export function useReportVideo({ petitionId, video }: { petitionId: string; video: Video }): Result {
	const { track } = useCampaignTracking();
	const { canReportVideo, currentUser } = useCanReportVideo(video);

	const report = useCallback(() => {
		const payload: TrackingProperties = {
			petition_id: petitionId,
			reporter_id: currentUser?.id,
			video_id: video.id,
			video_creator_id: video.user?.id,
		};

		track('supporter_voice_report_button_click', payload);
	}, [currentUser, petitionId, track, video]);

	return {
		data: { canReportVideo },
		actions: {
			report,
		},
	};
}
